import { Observable } from 'rxjs/Observable';
import { LOG_OUT_REQUESTED } from '../redux/account';
import { logUserOut } from '../utils/api';

import type { ActionObs, Store, Obs } from '../types';

export default function logoutEpic(action$: ActionObs, store: Store): Obs {
  return action$.ofType(LOG_OUT_REQUESTED).switchMap(() =>
    logUserOut()
      .map(() => ({ type: '' }))
      .catch(err => Observable.of({ type: '' })),
  );
}
